import { QueryClient } from 'react-query';

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60 * 30,
    useErrorBoundary: true,
  },
};

const queryClient = new QueryClient({ defaultOptions: queryConfig });

export default queryClient;
